<template>
  <div class="timeline--wrapper">
    <TimelineHeader @close="close" />
    <div id="timeline" class="timeline--inner">
      <div class="timeline--content">
        <TimelineHero />
        <div class="timeline-milestones">
          <PinnedContainer
            :year="year"
            :eds="eds"
            :members="members"
            :globeActive="globeActive"
            :visibleMembers="visibleMembers"
          />
          <Steps
            v-if="steps.length > 0"
            stepsRef="milestone"
            :steps="steps"
            :selectedDecade="selectedDecade"
            @step-scrolled="handleStep"
            @globe-toggle="globeToggle"
            @member-toggle="memberToggle"
          />
          <YearTracker :year="year" @scroll-to="scrollTo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimelineHeader from "./timeline/TimelineHeader.vue";
import milestones from "../source/milestones.json";
import eds from "../source/eds.json";
import members from "../source/members.json";
import Steps from "./timeline/steps/Steps.vue";
import TimelineHero from "./timeline/TimelineHero.vue";
import PinnedContainer from "./timeline/PinnedContainer.vue";
import YearTracker from "./timeline/YearTracker.vue";
import { ordinalNum } from "../assets/util.js";
import gsap from "gsap";

export default {
  components: {
    TimelineHeader,
    TimelineHero,
    PinnedContainer,
    Steps,
    YearTracker,
  },
  data() {
    return {
      year: null,
      eds: eds,
      members: members,
      steps: [],
      visibleMembers: [],
      globeActive: false,
      selectedDecade: null,
    };
  },
  beforeDestroy() {
    const timelines = gsap.globalTimeline.getChildren();
    const gridTls = timelines.filter((d) => d.data === "grid-tl");
    gridTls.forEach((d) => d.kill());
    this.milestones = [];
  },
  mounted() {
    this.formatMilestones();
  },
  methods: {
    formatMilestones() {
      let result = [];
      // Add Milestones
      for (const i in milestones) {
        const milestone = milestones[i];
        const year = Number(i);
        result.push({ year, milestones: [...milestone] });
      }
      // Add Member Countries
      for (const i in members) {
        const member = members[i];
        const year = Number(i);
        const yearExists = result.find((d) => d.year === year);
        yearExists
          ? (yearExists.countries = member)
          : result.push({ year: year, countries: member });
      }
      // Add Executive Directors
      for (const i in eds) {
        const order = Object.keys(eds).indexOf(i) + 1;
        const ed = eds[i];
        const year = Number(i);
        const yearExists = result.find((d) => d.year === year);
        if (yearExists) {
          const temp = yearExists.milestones.find((d) => d.ed);
          temp.milestone = `${ed.name} (${ed.country}) appointed ${ordinalNum[order]} IEA Executive Director`;
          temp.img = 1;
        }
      }
      result = result.sort((a, b) => a.year - b.year);
      result[result.length - 1].end = { end: "end" };
      this.steps = result;
    },
    scrollTo(decade) {
      this.selectedDecade = decade;
    },
    close() {
      this.$emit("handle-timeline");
    },
    handleStep(value) {
      this.year = Number(value);
    },
    globeToggle(active) {
      this.globeActive = active;
    },
    memberToggle({ action, year, i }) {
      let result = [...this.visibleMembers];
      let country = members[year][i].ISO3;
      if (action === "add") {
        result.push(country);
        this.visibleMembers = result;
      } else {
        let idx = result.indexOf(country);
        result.splice(idx, 1);
        this.visibleMembers = result;
      }
    },
  },
};
</script>

<style>
.timeline--wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 99;
}
.testing {
  width: 300px;
  height: 600px;
  background: #e3e3e3;
}
.timeline--inner {
  position: relative;
  width: inherit;
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.timeline--content {
  position: relative;
}
.hero-title--wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.hero-title {
  height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeline-milestones {
  width: 100%;
  background: #fff;
  z-index: 2;
  position: relative;
}
</style>
